/**
@jsxRuntime
classic */
/** @jsx jsx */
import {jsx} from '@emotion/core'
import {PriceCalculatorScreen} from '../components/price-calculator/price-calculator-screen'

function PriceCalculator() {
  return <PriceCalculatorScreen></PriceCalculatorScreen>
}

export {PriceCalculator}
